import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SpacingRow,
  SpacingRowAlign,
  SpacingRowItem,
  SpacingUnit,
} from 'components/ui';
import { DictionarySettingsDefaultValue } from 'stores/models/fieldsSettings';

import s from './DataRenderer.module.scss';

type DataRendererProps = {
  store: DictionarySettingsDefaultValue;
};

const DataRenderer: React.FC<DataRendererProps> = ({ store }) => {
  const { t } = useTranslation();

  return (
    <SpacingRow align={SpacingRowAlign.center} hSpacing={SpacingUnit.unit6}>
      <SpacingRowItem className={s.dataRenderer__textWrapper}>
        {store.selectedValueLabel ? (
          <Typography.Text>{store.selectedValueLabel}</Typography.Text>
        ) : (
          <Typography.Text type="secondary">
            {t('editForm.valueNotSet')}
          </Typography.Text>
        )}
      </SpacingRowItem>
    </SpacingRow>
  );
};

export default observer(DataRenderer);
